import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-report',
  styleUrls: ['./reports.component.scss'],
  template: `
      <div class="main no-padding">
          <header-menu></header-menu>
          <company-report *ngIf="typeBusiness == 'company'"></company-report>
          <establishment-report *ngIf="typeBusiness == 'establishment'"></establishment-report>
      </div>
  `
})
export class ReportsComponent implements OnInit {

  typeBusiness: string;

  constructor(private userService: UserService) {}

  ngOnInit() {
    const user = this.userService.getLoggedUser();
    this.typeBusiness = user.typeBusiness;
  }
}
